module.exports = __webpack_public_path__ + "static/media/logo.d3a07084.svg";